import React from "react";
import { connect } from "react-redux";
import CustomMainNavBar from "./CustomMainNavBar";
import CustomMenuNavBar from "./CustomMenuNavBar";
import CheckRender from "../Common/CheckRender";

const CustomHeader = (props) => {
  return (
    <>
      <CustomMainNavBar isLoginScreen={props.isLoginScreen} />

      <CheckRender allowed={props.showMenuNav}>
        <CustomMenuNavBar />
      </CheckRender>
    </>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(CustomHeader);